import { Injectable } from '@angular/core';
import { Skill } from './skill.model';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

export interface SkillsState extends EntityState<Skill> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'skills' })
export class SkillsStore extends EntityStore<SkillsState> {

  constructor() {
    super();
  }

}

